import app from 'firebase/app';
import "firebase/firestore"
import "firebase/storage"
import firebaseConfig from './config';

class Firebase { 

    constructor() {

        if(!app.apps.length ) app.initializeApp(firebaseConfig)
        this.db = app.firestore()
        this.storage = app.storage()

    }

    // Insertar a la base de datos
    addDocument(collection, data) {
        return this.db.collection(collection).add(data)
    }

}

const firebase = new Firebase()
export default firebase;